export { default } from './MentionsTextArea';
